import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Button/Button';
import styles from './FillWidthButton.module.scss';

const FillWidthButton = ({ className = '', ...props }) => (
  <Button
    className={`${styles['fill-width']} ${className} branded-button`}
    {...props}
  />
);

FillWidthButton.propTypes = {
  className: PropTypes.string
};

export default FillWidthButton;
